export default {
  // 交易方向
  transactionDirection: "扩展方向：",
  inflow: "流入",
  outflow: "流出",
  bidirectional: "双向",

  // 交易方向提示
  inflowTooltip: "节点向流入的方向扩展",
  outflowTooltip: "节点向流出的方向扩展",
  bidirectionalTooltip: "节点向流入和流出的方向同时扩展",

  // 节点操作
  nodeOperation: "节点操作：",
  directAssociation: "直接关联",
  batchExpansion: "批量扩展",
  batchBalanceQuery: "批量余额查询",
  commonCounterparty: "共同交易对手",
  exchangeExpansion: "交易所扩展",

  // 节点操作提示
  directAssociationTooltip: "可以直接关联出所选节点与节点之间的交易和关系边",
  batchExpansionTooltip: "批量扩展所选节点",
  batchBalanceQueryTooltip: "批量查询所选节点的余额",
  commonCounterpartyTooltip:
    "共同交易对手:分析多个地址共同流入或共同流出的交易对手",
  exchangeExpansionTooltip: "交易所扩展:扩展单个地址流入或流出到交易所的聚合点",

  // AI模型
  aiModel: "AI模型：",
  firstFeeTraceability: "首笔手续费追溯",
  multilayerTraceability: "多层追溯",
  transactionPathAnalysis: "交易路径分析",
  newOldStopModel: "新启旧停模型",
  singleChannelModel: "单通道中转模型",

  // AI模型提示
  firstFeeTraceabilityTooltip: "首笔手续费追溯:追溯单个地址5级之内的交易所地址",
  multilayerTraceabilityTooltip:
    "多层追溯: 追溯流单个地址最多3级之内的转入或者转出交易路径",
  transactionPathAnalysisTooltip:
    "交易路径分析:分析2级内多个起始地址到终点地址中的途径点和交易路径",
  newOldStopModelTooltip:
    "新启旧停模型:用于分析黑灰产地址的迁移行为。用户可指定目标地址与筛选条件，系统将自动检索该地址的最早或最新一笔交易，识别地址启用或停用状态。模型可发现黑灰产在更换收款地址时的整笔资金转移，有助于追踪其最新活跃地址或反向查找历史地址，为链上追踪与风险分析提供关键线索。",
  singleChannelModelTooltip:
    "单通道中转模型:用于识别黑灰产资金转移过程中的中转行为。系统会以指定地址为起点，逐层分析其资金流入和流出关系，寻找资金流高度集中的地址链路。模型会沿着这类高依赖的转移路径持续追踪，直到资金出现分散流动，从而揭示黑灰产资金的主要中转路径。",

  // 成功消息
  directionModifiedSuccess: "转账方向修改成功",
};
